import styled from "@emotion/styled";
export const StyledThumbnailsListComponent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: 20px;
  margin-right: 20px;
  max-width: 1400px;
  margin: auto;
  margin-bottom: 70px;
`;
